<div class="fuse-vertical-navigation-wrapper">

    <!-- Header -->
    <div class="fuse-vertical-navigation-header">
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="flex flex-col items-center mx-auto mt-6 mb-4 px-4">
                <img class="max-w-full max-h-[100px] object-contain"
                     [src]="logoUrl"
                     (error)="onLogoError()"
                     alt="Logo">
            </div>

            <!-- Church info card -->
            <div *ngIf="church" (click)="openStorageDetails()"
                 class="mx-4 mb-4 p-4 bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 cursor-pointer transition-all duration-300 hover:shadow-md hover:border-gray-300 dark:hover:border-gray-600">
                <!-- Church name -->
                <div class="text-base font-semibold text-gray-800 dark:text-gray-200 mb-3 leading-tight">
                    {{ church.name }}
                </div>

                <!-- Progress bar (uso real via /dashboard/storage-usage) -->
                <div class="w-full h-1.5 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden mb-2">
                    <div class="h-full rounded-full transition-all duration-300"
                         [ngClass]="storageBarColorClass"
                         [style.width.%]="getStoragePercentUsed()"></div>
                </div>

                <!-- Storage info -->
                <div class="text-xs text-gray-500 dark:text-gray-400 mb-4">
                    <ng-container *ngIf="storageComputing; else storageValue">
                        <mat-icon class="icon-size-4 mr-1 align-[-2px]" svgIcon="heroicons_outline:clock"></mat-icon>
                        <span>Calculando armazenamento...</span>
                    </ng-container>
                    <ng-template #storageValue>
                        {{ storageUsage ? (formatBytes(storageUsage.used_bytes) + ' / ' + formatBytes(storageUsage.total_bytes)) : 'Armazenamento não disponível' }}
                    </ng-template>
                </div>

                <!-- Footer: Plan badge + Members avatars -->
                <div class="flex items-center justify-between">
                    <!-- Plan badge -->
                    <div *ngIf="church.plan" [ngClass]="{
                        'p-1.5 rounded-lg flex items-center justify-center': true,
                        'bg-orange-100': church.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_BRONZE,
                        'bg-gray-100': church.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_SILVER,
                        'bg-yellow-100': church.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_GOLD,
                        'bg-cyan-100': church.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_DIAMOND,
                        'bg-red-100': church.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_NO_SUBSCRIPTION
                    }">
                        <mat-icon
                            [ngClass]="{
                                'icon-size-5': true,
                                'text-orange-600': church.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_BRONZE,
                                'text-gray-400': church.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_SILVER,
                                'text-yellow-500': church.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_GOLD,
                                'text-cyan-600': church.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_DIAMOND,
                                'text-red-600': church.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_NO_SUBSCRIPTION
                            }"
                            [svgIcon]="church.plan.name?.toLowerCase() === MessagesConstants.PLAN_KEY_NO_SUBSCRIPTION ? 'mat_outline:error_outline' : 'mat_solid:military_tech'">
                        </mat-icon>
                    </div>

                    <!-- Members avatars -->
                    <div class="flex items-center flex-shrink-0">
                        <!-- Skeleton: círculos sobrepostos + bloco do contador.
                             Estado INICIAL do card (`memberAvatarsLoading` nasce
                             true no componente E no serviço — regressão flash
                             corrigida 2026-09-18: a ordem de render é SEMPRE
                             skeleton → estado final, nunca placeholders antes). -->
                        <ng-container *ngIf="memberAvatarsLoading">
                            <div class="flex items-center" aria-hidden="true">
                                <div class="flex -space-x-2">
                                    <div class="w-7 h-7 rounded-full border-2 border-white dark:border-gray-800 animate-pulse bg-gray-200 dark:bg-gray-600"></div>
                                    <div class="w-7 h-7 rounded-full border-2 border-white dark:border-gray-800 animate-pulse bg-gray-200 dark:bg-gray-600"></div>
                                    <div class="w-7 h-7 rounded-full border-2 border-white dark:border-gray-800 animate-pulse bg-gray-200 dark:bg-gray-600"></div>
                                    <div class="w-7 h-7 rounded-full border-2 border-white dark:border-gray-800 animate-pulse bg-gray-200 dark:bg-gray-600"></div>
                                </div>
                                <div class="ml-1 w-7 h-7 rounded-full animate-pulse bg-gray-200 dark:bg-gray-600"></div>
                            </div>
                        </ng-container>

                        <!-- Pós-carga: fotos reais (S3) ou placeholders estáticos.
                             Os placeholders vivem EXCLUSIVAMENTE neste estado
                             terminal sem dados/permissão (!loading && avatares
                             vazio) — nunca no estado inicial (loading=true). -->
                        <ng-container *ngIf="!memberAvatarsLoading">
                            <!-- Stacked avatars -->
                            <div class="flex -space-x-2">
                                <!-- Fotos reais dos membros (cache do serviço). -->
                                <ng-container *ngIf="memberAvatars.length > 0">
                                    <ng-container *ngFor="let avatar of memberAvatars; trackBy: trackMemberAvatar">
                                        <img *ngIf="!avatar.failed"
                                             class="w-7 h-7 rounded-full border-2 border-white dark:border-gray-800 object-cover"
                                             [src]="avatar.avatar"
                                             [alt]="avatar.fullName"
                                             [title]="avatar.fullName"
                                             (error)="onMemberAvatarError(avatar)">
                                        <div *ngIf="avatar.failed"
                                             class="w-7 h-7 rounded-full border-2 border-white dark:border-gray-800 bg-gray-200 dark:bg-gray-600 flex items-center justify-center flex-shrink-0">
                                            <mat-icon class="icon-size-4 text-gray-400" svgIcon="mat_solid:person"></mat-icon>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <!-- Placeholders estáticos — fallback silencioso
                                     (sem permissão/erro): só pós-carga e SEM
                                     dados; fora do estado inicial ou do estado
                                     com fotos reais. -->
                                <ng-container *ngIf="memberAvatars.length === 0">
                                    <img class="w-7 h-7 rounded-full border-2 border-white dark:border-gray-800 object-cover"
                                         src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop"
                                         alt="Membro">
                                    <img class="w-7 h-7 rounded-full border-2 border-white dark:border-gray-800 object-cover"
                                         src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop"
                                         alt="Membro">
                                    <img class="w-7 h-7 rounded-full border-2 border-white dark:border-gray-800 object-cover"
                                         src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop"
                                         alt="Membro">
                                    <img class="w-7 h-7 rounded-full border-2 border-white dark:border-gray-800 object-cover"
                                         src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop"
                                         alt="Membro">
                                </ng-container>
                            </div>
                            <!-- Counter badge -->
                            <div class="ml-1 w-7 h-7 rounded-full bg-gray-800 dark:bg-gray-600 flex items-center justify-center flex-shrink-0">
                                <span class="text-xs font-medium text-white">+{{ storageUsage?.counters?.members_count ?? church.membersCount ?? '0' }}</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-content select="[fuseVerticalNavigationHeader]"></ng-content>
    </div>

    <!-- Content -->
    <div
        class="fuse-vertical-navigation-content max-h-[calc(100%-315px)]"
        fuseScrollbar
        [fuseScrollbarOptions]="{wheelPropagation: inner, suppressScrollX: true}"
        #navigationContent>

        <!-- Content header -->
        <div class="fuse-vertical-navigation-content-header">
            <ng-content select="[fuseVerticalNavigationContentHeader]"></ng-content>
        </div>

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside'">
                    <fuse-vertical-navigation-aside-item
                        [item]="item"
                        [name]="name"
                        [activeItemId]="activeAsideItemId"
                        [autoCollapse]="autoCollapse"
                        [skipChildren]="true"
                        (click)="toggleAside(item)"></fuse-vertical-navigation-aside-item>
                </ng-container>

                <!-- Basic -->
                <ng-container *ngIf="item.type === 'basic'">
                    <fuse-vertical-navigation-basic-item
                        [item]="item"
                        [name]="name"></fuse-vertical-navigation-basic-item>
                </ng-container>

                <!-- Collapsable -->
                <ng-container *ngIf="item.type === 'collapsable'">
                    <fuse-vertical-navigation-collapsable-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="autoCollapse"></fuse-vertical-navigation-collapsable-item>
                </ng-container>

                <!-- Divider -->
                <ng-container *ngIf="item.type === 'divider'">
                    <fuse-vertical-navigation-divider-item
                        [item]="item"
                        [name]="name"></fuse-vertical-navigation-divider-item>
                </ng-container>

                <!-- Group -->
                <ng-container *ngIf="item.type === 'group'">
                    <fuse-vertical-navigation-group-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="autoCollapse"></fuse-vertical-navigation-group-item>
                </ng-container>

                <!-- Spacer -->
                <ng-container *ngIf="item.type === 'spacer'">
                    <fuse-vertical-navigation-spacer-item
                        [item]="item"
                        [name]="name"></fuse-vertical-navigation-spacer-item>
                </ng-container>

            </ng-container>

        </ng-container>
    </div>

    <!-- Footer -->
    <div class="fuse-vertical-navigation-content-footer relative top-[5px] w-full">

    </div>

</div>

<!-- Aside -->
<ng-container *ngIf="activeAsideItemId">
    <div
        class="fuse-vertical-navigation-aside-wrapper"
        fuseScrollbar
        [fuseScrollbarOptions]="{wheelPropagation: false, suppressScrollX: true}"
        [@fadeInLeft]="position === 'left'"
        [@fadeInRight]="position === 'right'"
        [@fadeOutLeft]="position === 'left'"
        [@fadeOutRight]="position === 'right'">

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside' && item.id === activeAsideItemId">
                    <fuse-vertical-navigation-aside-item
                        [item]="item"
                        [name]="name"
                        [autoCollapse]="autoCollapse"></fuse-vertical-navigation-aside-item>
                </ng-container>

            </ng-container>

        </ng-container>

    </div>
</ng-container>
